import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
// 短信链接跳转
const TextMessageLinke = (props: any) => {
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    initData()
  }, [])

  const initData = () => {
    setIsLoading(true)
    request(`https://svi.shj.cn/api/api-wx/wx/miniapp/commons/VipMiniApp/createUrl`, {
      method: METHODS.POST,
      data: {
        path: '/pages/textMessageLink/index',
        envVersion: 'release', //release/trial/develop
      },
    })
      .then(res => {
        console.log(res)
        location.href = res
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return <div></div>
}

export default TextMessageLinke
